<template>
<div>
    <el-dialog title="请选择技术通知" width="80%" :visible.sync="viewData.visible" append-to-body>
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="项目编码:">
                <el-input size="small" v-model="dataForm.projectCode" placeholder="项目编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="项目名称:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="技术包名称:">
                <el-input size="small" v-model="dataForm.technicalName" placeholder="技术包名称" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="车型:">
                <el-input size="small" v-model="dataForm.carType" placeholder="车型" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="id" size="mini" bProject style="width: 100%" :default-expand-all="false" @current-change="currentChange" highlight-current-row border :header-cell-style="{background:'#f5f5f5'}" class="mb15">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectCode" header-align="center" align="left" label="项目编码">
                </el-table-column>
                <el-table-column prop="projectName" header-align="center" align="left" label="项目名称">
                </el-table-column>
                <el-table-column prop="technicalCode" header-align="center" align="left" label="通知编码">
                </el-table-column>
                <el-table-column prop="technicalName" header-align="center" align="left" label="通知名称">
                </el-table-column>
                <el-table-column prop="carType" header-align="center" align="left" label="车型">
                </el-table-column>
                <el-table-column prop="appartmentCount" header-align="center" align="right" label="零件数">
                </el-table-column>
                <el-table-column prop="appartmentSumCount" header-align="center" align="right" label="零件总数">
                </el-table-column>
                <el-table-column prop="technicalStatus" header-align="center" align="center" label="状态" width="80">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.technicalStatus)">{{statusFormat(scope.row.technicalStatus)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="170">
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" style="text-align: right" class="mb15">
            </el-pagination>
        </div>
        <el-row :gutter="40">
            <el-col :span="24" style="text-align: right">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <!-- 询价中 -->
                <el-button size="small" type="primary" @click="confirm()">
                    确认
                </el-button>
            </el-col>
        </el-row>
    </el-dialog>
</div>
</template>

<script>
import {
    DIALOG_CLOSED_TYPE,
    getLabelByValue,
    TECHNICAL_INFO_STATUS
} from "@/utils/const";
import {
    fetchTechList
} from "@/controller/tech";
import moment from "moment";
export default {
    data() {
        return {
            documentClientHeight: document.documentElement["clientHeight"] - 250,
            dataForm: {
                // 通知表里的字段
                projectCode: "",
                projectName: "",
                technicalName: "",
                carType: "",
                technicalStatus: "",
                projectId: "",
                technicalId: "",
                technicalCode: "",
                projectManagerId: "",
                projectManagerName: "",
                projectType: "",
                appartmentCount: "",
                appartmentSumCount: "",
                remark: "",
                // xxxx:"",
            },
            TECHNICAL_INFO_STATUS: TECHNICAL_INFO_STATUS,
            getLabelByValue: getLabelByValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
            viewData: {
                visible: false,
                width: "",
            },
            userList: [],
            currentRow: {},
        };
    },
    mounted() {},
    activated() {
        this.getDataList();
    },
    methods: {
        dateFormat: function (row, column) {
            var date = row[column.property];
            if (date == undefined) {
                return "";
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss");
        },
        // 获取数据列表
        getDataList() {
            // console.log(this.getDataList)
            this.dataListLoading = true;
            fetchTechList({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                projectCode: this.dataForm.projectCode,
                projectName: this.dataForm.projectName,
                technicalName: this.dataForm.technicalName,
                carType: this.dataForm.carType,
                technicalStatus: this.dataForm.technicalStatus,
            }).then((data) => {
                // console.log(data, "data");
                if (data && data.code === "00") {
                    this.dataList = data.body.records;
                    this.totalPage = data.body.total;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        currentChange(currentRow) {
            console.log(currentRow);
            this.currentRow = currentRow;
        },
        open() {
            this.viewData.visible = true;
            this.getDataList();
        },
        onClosed(params) {
            console.log(params);
            return;
        },
        // 筛选按钮弹框取消
        cancel() {
            this.close();
        },
        close(option = DIALOG_CLOSED_TYPE.CLOSE) {
            if (!this.viewData.visible) {
                return;
            }
            if (this.multiple) {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.userList,
                });
            } else {
                this.onClosed({
                    option,
                    sender: this,
                    data: this.currentRow,
                });
            }
            this.viewData.visible = false;
        },
        confirm() {
            this.close(DIALOG_CLOSED_TYPE.CONFIRM);
        },
        statusFormat: function (value) {
            // var value = row[column.property]
            if (!value) {
                return "";
            }
            return getLabelByValue(TECHNICAL_INFO_STATUS, value);
        },
        getStatusClass(status) {
            let className = "";
            switch (status) {
                case "0":
                    className = "text-danger";
                    break;
                case "1":
                    className = "text-success";
                    break;
                default:
                    className = "";
                    break;
            }
            return className;
        },
    },
};
</script>

<style lang="scss" scoped>
.el-dialog__body {
    .org-dialog-form {
        width: 100%;
    }
}

.linetext {
    white-space: pre-line;
}

.el-table__body {
    tr.current-row>td {
        color: #fff;
        background-color: #409EFF !important;
    }
}
</style>
